var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main-layout',{staticClass:"padded"},[(_vm.termStore.currentTerm)?_c('div',{staticClass:"pvp-container"},[_c('h1',{staticClass:"title"},[_vm._v(_vm._s(_vm.termStore.currentTerm.title))]),_c('wysiwyg-viewer',{domProps:{"innerHTML":_vm._s(_vm.termStore.currentTerm.text)}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }